// apps/web/src/routes/analytics.tsx
import { useState } from 'react'
import useSWR from 'swr'
import { Card, CardContent, CardHeader } from '@viecxanh/chat-ui/card'
import { Skeleton } from '@viecxanh/chat-ui/skeleton'
import { Input } from '@viecxanh/chat-ui/input'
import {
  LineChart, Line, BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, ResponsiveContainer, Legend,
} from 'recharts'
import { api } from '../lib/api-client'

export function AnalyticsPage() {
  const today = new Date().toISOString().slice(0, 10)
  const thirtyDaysAgo = new Date(Date.now() - 30 * 86400_000).toISOString().slice(0, 10)
  const [from, setFrom] = useState(thirtyDaysAgo)
  const [to, setTo] = useState(today)

  const params = { from, to }

  const { data: msgData, isLoading: l1 } = useSWR(
    ['/api/admin/analytics/messages-per-day', params],
    () => api.get('/api/admin/analytics/messages-per-day', params),
  )
  const { data: channelData, isLoading: l2 } = useSWR(
    ['/api/admin/analytics/by-channel', params],
    () => api.get('/api/admin/analytics/by-channel', params),
  )
  const { data: rtData, isLoading: l3 } = useSWR(
    ['/api/admin/analytics/response-time', params],
    () => api.get('/api/admin/analytics/response-time', params),
  )

  return (
    <div className="p-6 space-y-6">
      <div className="flex items-center gap-4">
        <h1 className="text-xl font-semibold">Thống kê</h1>
        <Input type="date" value={from} onChange={(e) => setFrom(e.target.value)} className="h-8 w-36" />
        <span className="text-slate-400">→</span>
        <Input type="date" value={to} onChange={(e) => setTo(e.target.value)} className="h-8 w-36" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card>
          <CardHeader><p className="font-medium">Tin nhắn theo ngày</p></CardHeader>
          <CardContent>
            {l1 ? <Skeleton className="h-48" /> : (
              <ResponsiveContainer width="100%" height={200}>
                <LineChart data={msgData as unknown[]}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                  <YAxis tick={{ fontSize: 11 }} />
                  <Tooltip />
                  <Line type="monotone" dataKey="count" stroke="#22c55e" strokeWidth={2} dot={false} />
                </LineChart>
              </ResponsiveContainer>
            )}
          </CardContent>
        </Card>

        <Card>
          <CardHeader><p className="font-medium">Tin nhắn theo kênh</p></CardHeader>
          <CardContent>
            {l2 ? <Skeleton className="h-48" /> : (
              <ResponsiveContainer width="100%" height={200}>
                <BarChart data={channelData as unknown[]}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="channel" tick={{ fontSize: 11 }} />
                  <YAxis tick={{ fontSize: 11 }} />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="count" fill="#22c55e" />
                </BarChart>
              </ResponsiveContainer>
            )}
          </CardContent>
        </Card>

        <Card className="lg:col-span-2">
          <CardHeader><p className="font-medium">Thời gian phản hồi (phút)</p></CardHeader>
          <CardContent>
            {l3 ? <Skeleton className="h-48" /> : (
              <ResponsiveContainer width="100%" height={200}>
                <LineChart data={rtData as unknown[]}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="date" tick={{ fontSize: 11 }} />
                  <YAxis tick={{ fontSize: 11 }} />
                  <Tooltip />
                  <Line type="monotone" dataKey="avg_minutes" stroke="#3b82f6" strokeWidth={2} dot={false} />
                </LineChart>
              </ResponsiveContainer>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  )
}
